import React, {
  useState,
  useEffect,
  useRef,
  useContext,
  useMemo,
  useCallback,
} from "react";
import { Link, useHistory } from "react-router-dom";
import GoogleMapReact from "google-map-react";
import NVD3Chart from "react-nvd3";
import d3 from "d3";
import Chart from "react-apexcharts";
import DateRangePicker from "react-bootstrap-daterangepicker";
import Moment from "moment";
import { countryList } from "../../components/Conteries";
import {
  Panel,
  PanelHeader,
  PanelBody,
} from "../../components/panel/panel.jsx";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { Pie } from "react-chartjs-2";
import Config from "../../Config.js";
import LoaderSpinner from "../../components/Loaderspinner/LoaderSpinner";
import { CSVLink } from "react-csv";
import { getArticleTimeWiseScanningAnalyticReport } from "../../api/reportApi";

import {
  countrycsvheaders,
  Citycsvheaders,
  Lablecsvheaders,
} from "./CsvHeaders/CsvHeaders";
import swal from "sweetalert";

import { TimeWiseAnalysis } from '../../components/Modal/modal';
import { Countrywisescans } from '../../components/Modal/modal';
import { Articleperforminglabel } from '../../components/Modal/modal';

import {Locationscitywisescans} from '../../components/DataTable/datatable';
import {Bestperforminglabeldetail} from '../../components/DataTable/datatable';

const Articlereports = (props) => {
  const { Articlelist } = props;

  const { ArticleID } = props;
  let history = useHistory();
  const [modalCountry, setmodalCountry] = useState(false);
  const [IstimewisemodalOpen, setIstimewisemodalOpen] = useState(false);

  const [modalCity, setmodalCity] = useState(false);
  const [modalLabel, setmodalLabel] = useState(false);
  const [ArticleAttributeList, setArticleAttributeList] = useState([]);
  const [graphData, setgraphData] = useState(null);
  const [selectStartDate, setselectStartDate] = useState(
    Moment(new Date()).subtract("days", 30)
  );
  const [selectEndDate, setselectEndDate] = useState(Moment(new Date()));
  const [Isloading, setIsloading] = useState(false);

  const [articleID, setarticleID] = useState("");
  const [ArticleAttributeID, setArticleAttributeID] = useState("");
  const [bestscancountry, setbestscancountryisall] = useState(false);
  const [DatatableLebalList, setDatatableLebalList] = useState([]);
  const [bestScanLableishow, setbestScanLableishow] = useState(false);

  const [Locationswisecanning, setLocationswisecanning] = useState([]);
  const [LocationsCitywisecanning, setLocationsCitywisecanning] = useState([]);
  const [Lablewisecanning, setLablewisecanning] = useState([]);

  const [bDownloadReady, setDownloadReady] = useState(false);
  const [countrycsvdata, setcountrycsvdata] = useState([]);

  const [cityDownloadReady, setcityDownloadReady] = useState(false);
  const [Citycsvdata, setCitycsvdata] = useState([]);

  const [LableDownloadReady, setLableDownloadReady] = useState(false);
  const [Lablecsvdata, setLablecsvdata] = useState([]);
  const [DatatablecountryWiseScanLits, setDatatablecountryWiseScanLits] =
    useState([]);

  const [articleTimeWiseScanListDetalis, setarticleTimeWiseScanListDetalis] =
    useState([]);

  const [bestscancountryishow, setbestscancountryishow] = useState(false);
  const [bestsCityallshow, setbestsCityallshow] = useState(false);
  const [bestScanLabelDetlisisall, setbestScanLabelDetlisisall] =
    useState(false);
  const countrycsvRef = useRef(null);
  const CitycsvRef = useRef(null);
  const LablecsvRef = useRef(null);

  useEffect(async () => {
    let checkLogin = localStorage.getItem("loginUserID");
    if (
      checkLogin === "" ||
      checkLogin === null ||
      checkLogin === "null" ||
      checkLogin === undefined
    ) {
      history.push("/Login");
    } else {
      if (ArticleID !== null && ArticleID !== undefined && ArticleID !== "") {
        localStorage.setItem("localArticleAttribute", "");
        localStorage.setItem("localArticleID", ArticleID);
        GetAllArticleAttribute(ArticleID);
      } else {
        localStorage.setItem("localArticleID", "");
        localStorage.setItem("localArticleAttribute", "");
        LoadGraph(selectStartDate, selectEndDate, "", "");
      }
    }
  }, []);

  const LoadGraph = async (stardate, enddate, articleid, attributeid) => {
    setIsloading(true);
    document.body.style.overflow = "hidden";
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    let GraphstartDate = Moment(stardate).format("YYYY/MM/DD") + " 00:00:00";
    let GraphEndDate = Moment(enddate).format("YYYY/MM/DD") + " 00:00:00";
    let subUserIDList = localStorage.getItem("subUserIDList");
    fetch(
      Config.apiUrl +
      "QRCodeScanHistory/ArticleScanningAnalyticReport?StartDate=" +
      GraphstartDate +
      "&EndDate=" +
      GraphEndDate +
      "&PageCount=10000" +
      "&ArticleId=" +
      articleid +
      "&ArticleVariantId=" +
      attributeid,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          userCompanyID: loginid,
          subUserCompanyID: subUserIDList,
          Authorization: "Bearer " + Auth0token,
        },
      }
    )
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw new Error("Something went wrong");
      })
      .then((responseJson) => {
        setIsloading(false);
        document.body.style.overflow = "auto";
        setgraphData(responseJson);
        let responseJsonTemp = responseJson?.articleCountryWiseScanList;
        let bestPerformLabelWiseListTemp =
          responseJson?.articlePerformLabelWiseList.filter(
            (x) => x.labelId !== null
          );
        // let bestPerformLabelWiseListTemp = responseJson?.articlePerformLabelWiseList;
        if (bestPerformLabelWiseListTemp) {
          bestPerformLabelWiseListTemp.forEach((item, index) => {
            item.sr = index + 1;
          });
          setDatatableLebalList(bestPerformLabelWiseListTemp);
        } else {
          setDatatableLebalList([]);
        }
        if (responseJsonTemp) {
          responseJsonTemp.forEach((item, index) => {
            item.sr = index + 1;
          });
          setDatatablecountryWiseScanLits(
            responseJsonTemp.filter((x) => x.name !== "country13")
          );
        } else {
          setDatatablecountryWiseScanLits([]);
        }
      })
      .catch((error) => {
        setIsloading(false);
        document.body.style.overflow = "auto";
        setgraphData(null);
      });
  };

  const toggleCountry = (item) => {
    setmodalCountry(!modalCountry);
  };

  const getCountrywisescanningDetail = (CountryName) => {
    if (
      CountryName?.name !== null &&
      CountryName?.name !== undefined &&
      CountryName?.name !== ""
    ) {
      let GraphstartDate =
        Moment(selectStartDate).format("YYYY/MM/DD") + " 00:00:00";
      let GraphEndDate =
        Moment(selectEndDate).format("YYYY/MM/DD") + " 00:00:00";
      let loginid = localStorage.getItem("loginUserID");
      let Auth0token = localStorage.getItem("Auth0token");
      setIsloading(true);
      document.body.style.overflow = "hidden";

      let myArticleID = localStorage.getItem("localArticleID");
      let localArticleAttribute = localStorage.getItem("localArticleAttribute");
      if (!localArticleAttribute) {
        localArticleAttribute = "";
      }
      if (!myArticleID) {
        myArticleID = "";
      }
      fetch(
        Config.apiUrl +
        "QRCodeScanHistory/ArticleLocationsCountryWiseReportScansDetails?StartDate=" +
        GraphstartDate +
        "&EndDate=" +
        GraphEndDate +
        "&CountryName=" +
        CountryName?.name +
        "&PageCount=10000" +
        "&ArticleId=" +
        myArticleID +
        "&ArticleVariantId=" +
        localArticleAttribute,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      )
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          throw new Error("Something went wrong");
        })
        .then((responseJson) => {
          setmodalCountry(true);
          setLocationswisecanning(responseJson);
          setIsloading(false);
          document.body.style.overflow = "auto";
        })
        .catch((error) => {
          setmodalCountry(false);
          document.body.style.overflow = "auto";
          setLocationswisecanning([]);
        });
    } else {
      setmodalCountry(false);
      setLocationswisecanning([]);
    }
  };

  const toggleCity = (item) => {
    //getcitywisescanningDetail(item);
    setmodalCity(!modalCity);
  };

  const getcitywisescanningDetail = (CountryName) => {
    if (
      CountryName?.countryName !== null &&
      CountryName?.countryName !== undefined &&
      CountryName?.countryName !== ""
     
    ) {
      var cityname = "";
      if (
        CountryName?.cityName !== null &&
        CountryName?.cityName !== "null" &&
        CountryName?.cityName !== undefined &&
        CountryName?.cityName !== ""
      ) {
        cityname = CountryName?.cityName;
      }
      let GraphstartDate =
        Moment(selectStartDate).format("YYYY/MM/DD") + " 00:00:00";
      let GraphEndDate =
        Moment(selectEndDate).format("YYYY/MM/DD") + " 00:00:00";
      let loginid = localStorage.getItem("loginUserID");
      let Auth0token = localStorage.getItem("Auth0token");
      setIsloading(true);
      document.body.style.overflow = "hidden";

      let myArticleID = localStorage.getItem("localArticleID");
      let localArticleAttribute = localStorage.getItem("localArticleAttribute");
      if (!localArticleAttribute) {
        localArticleAttribute = "";
      }
      if (!myArticleID) {
        myArticleID = "";
      }

      fetch(
        Config.apiUrl +
        "QRCodeScanHistory/ArticleLocationsCityWiseReportScansDetails?StartDate=" +
        GraphstartDate +
        "&EndDate=" +
        GraphEndDate +
        "&CountryName=" +
        CountryName?.countryName +
        "&cityName=" +
        cityname +
        "&PageCount=10000" +
        "&ArticleId=" +
        myArticleID +
        "&ArticleVariantId=" +
        localArticleAttribute,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      )
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          throw new Error("Something went wrong");
        })
        .then((responseJson) => {
          setmodalCity(true);
          // setLocationsCitywisecanning(responseJson)
          let responseJsonTemp = responseJson;
          if (responseJsonTemp) {
            responseJsonTemp.forEach((item, index) => {
              item.sr = index + 1;
            });
            setLocationsCitywisecanning(responseJsonTemp);
          } else {
            setLocationsCitywisecanning([]);
          }
          setIsloading(false);
          document.body.style.overflow = "auto";
        })
        .catch((error) => {
          setmodalCity(false);
          document.body.style.overflow = "auto";
          setLocationsCitywisecanning([]);
        });
    } else {
      setmodalCity(false);
      setLocationsCitywisecanning([]);
      swal("City name not found ");
    }
  };
  const toggleLabel = (item) => {
    // getLablewisescanningDetail(item);
    setmodalLabel(!modalLabel);
  };

  const getLablewisescanningDetail = (Lableitem) => {
    if (
      Lableitem?.labelId !== null &&
      Lableitem?.labelId !== undefined &&
      Lableitem?.labelId !== ""
    ) {
      let GraphstartDate =
        Moment(selectStartDate).format("YYYY/MM/DD") + " 00:00:00";
      let GraphEndDate =
        Moment(selectEndDate).format("YYYY/MM/DD") + " 00:00:00";
      let loginid = localStorage.getItem("loginUserID");
      let Auth0token = localStorage.getItem("Auth0token");
      setIsloading(true);
      document.body.style.overflow = "hidden";

      let myArticleID = localStorage.getItem("localArticleID");
      let localArticleAttribute = localStorage.getItem("localArticleAttribute");
      if (!localArticleAttribute) {
        localArticleAttribute = "";
      }
      if (!myArticleID) {
        myArticleID = "";
      }

      fetch(
        Config.apiUrl +
        "QRCodeScanHistory/ArticleLabelWiseReportScansDetails?StartDate=" +
        GraphstartDate +
        "&EndDate=" +
        GraphEndDate +
        "&LabelID=" +
        Lableitem?.labelId +
        "&PageCount=10000" +
        "&ArticleId=" +
        myArticleID +
        "&ArticleVariantId=" +
        localArticleAttribute,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      )
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          throw new Error("Something went wrong");
        })
        .then((responseJson) => {
          setmodalLabel(true);
          let responseJsonTemp = responseJson;
          if (responseJsonTemp) {
            responseJsonTemp.forEach((item, index) => {
              item.sr = index + 1;
            });
            setLablewisecanning(responseJsonTemp);
          } else {
            setLablewisecanning([]);
          }

          setIsloading(false);
          document.body.style.overflow = "auto";
        })
        .catch((error) => {
          setIsloading(false);
          setmodalLabel(false);
          document.body.style.overflow = "auto";
          setLablewisecanning([]);
        });
    } else {
      setIsloading(false);
      setmodalLabel(false);
      setLablewisecanning([]);
      console.log("Lable Id Not Found");
    }
  };

 
  const dateRange = {
    currentWeek:
      Moment(selectStartDate).format("DD / MM / YYYY") +
      " - " +
      Moment(selectEndDate).format("DD / MM / YYYY"),

    prevWeek:
      Moment(selectStartDate).format("D / MM / YYYY") +
      " - " +
      Moment(selectEndDate).format("D / MM / YYYY"),
  
  };

  const handleDateApplyEvent = (event, picker) => {
    var startDate = picker.startDate;
    var endDate = picker.endDate;
    var gap = endDate.diff(startDate, "days");

    var currentWeek =
      startDate.format("D MMMM YYYY") + " - " + endDate.format("D MMMM YYYY");
    var prevWeek =
      Moment(startDate).subtract("days", gap).format("D MMMM") +
      " - " +
      Moment(startDate).subtract("days", 1).format("D MMMM YYYY");

    setselectEndDate(new Date(picker.endDate));
    setselectStartDate(new Date(picker.startDate));
    LoadGraph(picker.startDate, picker.endDate, articleID, ArticleAttributeID);
  
  };


  const areaChartOptions = {
    pointSize: 0.5,
    useInteractiveGuideline: true,
    durection: 300,
    showControls: false,
    controlLabels: {
      stacked: "Stacked",
    },
    yAxis: {
      tickFormat: d3.format(",.0f"),
    },
    xAxis: {
      tickFormat: function (d) {
        var monthsName = [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ];
        console.log("446", d);
        d = new Date(parseInt(d));
        console.log("447", d);
        d = monthsName[d.getMonth()] + " " + d.getDate();
        console.log("451", d);
        return d;
      },
    },
  };
  const map = {
    center: {
      lat: 59.95,
      lng: 30.33,
    },
    zoom: 9,
  };
  const date = new Date();

  const pieChart = {
    data: {
      labels: ["Android", "ISO"],
      datasets: [
        {
          data: [300, 160],
          height: [10],
          width: [10],
          backgroundColor: ["#5B8FF9", "#61DDAA"],
          borderColor: ["#5B8FF9", "#61DDAA"],
          borderWidth: 2,
          label: "My dataset",
        },
      ],
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
    },
  };

  const GetAllArticleAttribute = async (ArticleID) => {
    try {
      let loginid = localStorage.getItem("loginUserID");
      let Auth0token = localStorage.getItem("Auth0token");
      let EmaptyArrry = [];
      setArticleAttributeList(EmaptyArrry);
      setArticleAttributeID("");
      if (ArticleID !== null && ArticleID !== "" && ArticleID !== undefined) {
        LoadGraph(selectStartDate, selectEndDate, ArticleID, "");
        await fetch(
          Config.apiUrl + "AttributeValueMap?articleProductID=" + ArticleID,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              userCompanyID: loginid,
              Authorization: "Bearer " + Auth0token,
            },
          }
        ).then((resp1) => {
          resp1.json().then((result) => {
            setarticleID(ArticleID);
            localStorage.setItem("localArticleID", ArticleID);
            setArticleAttributeList(result);
          });
        });
      } else {
        LoadGraph(selectStartDate, selectEndDate, "", "");
        localStorage.setItem("localArticleID", "");
        setArticleAttributeList(EmaptyArrry);
        setarticleID("");
      }
    } catch (error) {
      let EmaptyArrry = [];
      setArticleAttributeList(EmaptyArrry);
      localStorage.setItem("localArticleID", "");
      alert(error);
    }
  };
  const selectArticleAttribute = (AttributeID) => {
    localStorage.setItem("localArticleAttribute", AttributeID);
    let localArticleID = localStorage.getItem("localArticleID");
    LoadGraph(selectStartDate, selectEndDate, localArticleID, AttributeID);
    setArticleAttributeID(AttributeID);
  };

  useEffect(() => {
    if (countrycsvRef && countrycsvRef.current && bDownloadReady) {
      countrycsvRef.current.link.click();
      setDownloadReady(false);
    }
  }, [bDownloadReady]);

  const handleActioncountry = (actionType) => {
    if (actionType === "DOWNLOAD") {
      if (Locationswisecanning.length > 0) {
        let withheder = [];
        let csvdata = [...Locationswisecanning];
        for (let index = 0; index < csvdata.length; index++) {
          let element = csvdata[index];
          let tempdata = {
            sr: index + 1,
            cityName: element.cityName ? element.cityName : "N/A",
            totalScanCount: element.totalScanCount,
            countryName: element.countryName ? element.countryName : "N/A",
          };
          withheder.push(tempdata);
        }
        setcountrycsvdata(withheder);
        setDownloadReady(true);
      }
    }
  };

  useEffect(() => {
    if (CitycsvRef && CitycsvRef.current && cityDownloadReady) {
      CitycsvRef.current.link.click();
      setcityDownloadReady(false);
    }
  }, [cityDownloadReady]);
  const handleActionCity = (actionType) => {
    if (actionType === "DOWNLOAD") {
      if (LocationsCitywisecanning.length > 0) {
        let withheder = [];
        let csvdata = [...LocationsCitywisecanning];
        for (let index = 0; index < csvdata.length; index++) {
          let element = csvdata[index];
          let Fileimagepath = "";
          if (element.productImagepath) {
            Fileimagepath = Config.contentUrl + element.productImagepath;
          }
          let tempdata = {
            sr: index + 1,
            cityName: element.cityName ? element.cityName : "N/A",
            totalScanCount: element.totalScanCount,
            countryName: element.countryName ? element.countryName : "N/A",
            itemName: element.productName ? element.productName : "N/A",
            image: element.productImagepath ? Fileimagepath : "N/A",
          };
          withheder.push(tempdata);
        }
        setCitycsvdata(withheder);
        setcityDownloadReady(true);
      }
    }
  };

  useEffect(() => {
    if (LablecsvRef && LablecsvRef.current && LableDownloadReady) {
      LablecsvRef.current.link.click();
      setLableDownloadReady(false);
    }
  }, [LableDownloadReady]);
  const handleActionLable = (actionType) => {
    if (actionType === "DOWNLOAD") {
      if (Lablewisecanning.length > 0) {
        let withheder = [];
        let csvdata = [...Lablewisecanning];
        for (let index = 0; index < csvdata.length; index++) {
          let element = csvdata[index];

          let Fileimagepath = "";
          if (element.productImagepath) {
            Fileimagepath = Config.contentUrl + element.productImagepath;
          }
          let tempdata = {
            sr: index + 1,
            categoryName: element.lableName ? element.lableName : "N/A",
            totalScanCount: element.totalScanCount,
            itemName: element.productName ? element.productName : "N/A",
            image: element.productImagepath ? Fileimagepath : "N/A",
          };
          withheder.push(tempdata);
        }
        setLablecsvdata(withheder);
        setLableDownloadReady(true);
      }
    }
  };

  const ToggleTimewisemodalOpen = () => {
    setIstimewisemodalOpen(!IstimewisemodalOpen);
  };

  const GetArticleTimeWiseScanningAnalyticReport = async () => {
    let StartDate = Moment(selectStartDate).format("YYYY/MM/DD") + " 00:00:00";
    let EndDate = Moment(selectEndDate).format("YYYY/MM/DD") + " 00:00:00";
    let data = await getArticleTimeWiseScanningAnalyticReport(
      StartDate,
      EndDate,
      articleID,
      ArticleAttributeID,
      10000
    );
    ToggleTimewisemodalOpen();
    setarticleTimeWiseScanListDetalis(data);
  };
  const togglecountryTableclosed = () => {
    setbestscancountryishow(!bestscancountryishow);
  };
  // const togglecountryTableclosed = useCallback(() => {
  //   setbestscancountryishow(!bestscancountryishow);
  // }, []);
  const toggleLableTableclosed = () => {
    setbestScanLableishow(false);
  };

 
 
  return (
    <div>
      <LoaderSpinner isrefresh={Isloading} />
      <h1 className="page-header mb-3">Article scanning analytics</h1>
      <div className="d-sm-flex align-items-center mb-3">
        <DateRangePicker
          startDate={selectStartDate}
          endDate={selectEndDate}
          onApply={handleDateApplyEvent}
        >
          <button className="btn btn-inverse mr-2 text-truncate">
            <i className="fa fa-calendar fa-fw text-white-transparent-5 ml-n1"></i>
            <span>{dateRange.currentWeek}</span>
            <b className="caret"></b>
          </button>
        </DateRangePicker>
      </div>
      <div className="row justify-content-center">
        <div className="col-xl-12">
          <div className="card border-0 bg-dark text-white mb-3 overflow-hidden">
            <div className="card-body">
              <div
                className=" p-15"
                style={{ borderWidth: "1px", borderStyle: "dashed" }}
              >
                <form action="" method="POST">
                  <div className="row align-items-center">
                    <div className="form-group col-xl-9 col-lg-10 col-md-12  row align-items-center mb-0">
                      <label className="col-form-label col-lg-5  col-md-12">
                        Select Article
                      </label>
                      {/* // ProductID === null || ProductID === undefined || ProductID === "" ? */}
                      <div className="col-lg-7 col-md-8">
                        <select
                          value={articleID}
                          class="default-select2 form-control mr-2"
                          onChange={(e) => {
                            GetAllArticleAttribute(e.target.value);
                          }}
                        >
                          <option value={""}> --- Select Article --- </option>
                          {Articlelist !== undefined && Articlelist !== null ? (
                            Articlelist?.map((item, i) => (
                              <option value={item?._id}>
                                {item?.articleName ? item?.articleName : ""}
                              </option>
                            ))
                          ) : (
                            <></>
                          )}
                        </select>
                      </div>
                      {/* // : <div className="col-lg-7 col-md-8">
                        //   <select class="default-select2 form-control mr-2" onChange={(e) => { GetAllArticleAttribute(e.target.value) }}>
                        //     <option value={ProductID?._id}>{ProductID?.articleName ? ProductID?.articleName : 'N/A'}</option>
                        //   </select>
                        // </div> */}
                    </div>

                    <div className="col-xl-2 col-lg-2 col-md-12 mt-2 mt-lg-0 d-flex justify-content-start pl-2 pl-lg-0 px-4">
                      {/* <button className="btn  btn-primary mr-3">GO</button>*/}
                      {/* <Link
                        to="/qrcodemanagement/article-qrcode"
                        className="btn  btn-purple"
                      >
                        Article list
                      </Link> */}
                       <Link
                        to="/article-qrcode"
                        className="btn  btn-purple"
                      >
                        Article list
                      </Link>
                    </div>
                  </div>
                  <div className="row align-items-center  mt-2">
                    <div className="form-group col-xl-9 col-lg-10 col-md-12  row align-items-center mb-0">
                      <label className="col-form-label col-lg-5  col-md-12">
                        Selection variant combination
                      </label>
                      <div className="col-lg-7 col-md-8">
                        <select
                          class="default-select2 form-control mr-2"
                          onChange={(e) => {
                            selectArticleAttribute(e.target.value);
                          }}
                        >
                          <option value={""}>
                            {" "}
                            --- Select Combination ---{" "}
                          </option>
                          {ArticleAttributeList !== undefined &&
                            ArticleAttributeList !== null ? (
                            ArticleAttributeList?.map((item, i) =>
                              item.attributeValue1 != "" &&
                                item.attributeValue2 != "" &&
                                item.attributeValue3 != "" &&
                                item.attributeValue4 != "" &&
                                item.attributeValue5 != "" ? (
                                <option value={item?._id}>
                                  {item.attributeValue1 +
                                    " / " +
                                    item.attributeValue2 +
                                    " / " +
                                    item.attributeValue3 +
                                    " / " +
                                    item.attributeValue4 +
                                    " / " +
                                    item.attributeValue5}
                                </option>
                              ) : item.attributeValue1 != "" &&
                                item.attributeValue2 != "" &&
                                item.attributeValue3 != "" &&
                                item.attributeValue4 != "" &&
                                item.attributeValue5 === "" ? (
                                <option value={item?._id}>
                                  {item.attributeValue1 +
                                    " / " +
                                    item.attributeValue2 +
                                    " / " +
                                    item.attributeValue3 +
                                    " / " +
                                    item.attributeValue4}
                                </option>
                              ) : item.attributeValue1 != "" &&
                                item.attributeValue2 != "" &&
                                item.attributeValue3 != "" &&
                                item.attributeValue4 === "" &&
                                item.attributeValue5 === "" ? (
                                <option value={item?._id}>
                                  {item.attributeValue1 +
                                    " / " +
                                    item.attributeValue2 +
                                    " / " +
                                    item.attributeValue3}
                                </option>
                              ) : item.attributeValue1 != "" &&
                                item.attributeValue2 != "" &&
                                item.attributeValue3 === "" &&
                                item.attributeValue4 === "" &&
                                item.attributeValue5 === "" ? (
                                <option value={item?._id}>
                                  {item.attributeValue1 +
                                    " / " +
                                    item.attributeValue2}
                                </option>
                              ) : item.attributeValue1 != "" &&
                                item.attributeValue2 === "" &&
                                item.attributeValue3 === "" &&
                                item.attributeValue4 === "" &&
                                item.attributeValue5 === "" ? (
                                <option value={item?._id}>
                                  {item.attributeValue1}
                                </option>
                              ) : (
                                <></>
                              )
                            )
                          ) : (
                            <></>
                          )}
                        </select>
                      </div>
                    </div>

                    {/* <div className="col-lg-3 col-md-12 mt-2 mt-lg-0 d-flex justify-content-start pl-2 pl-lg-0 px-4">
                      <button className="btn  btn-primary mr-3">GO</button>
                    </div> */}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row justify-content-center">
        <div className="col-xl-12">
          <div className="card border-0 bg-dark text-white mb-3 overflow-hidden">
            <div className="card-body">
              <div className="row">
                <div className="col-md-12 d-flex justify-content-center">
                  <div className="table-responsive">
                    <table
                      className="table table-bordered m-b-0"
                      style={{ color: "#FFFFFF" }}
                    >
                      <thead style={{ backgroundColor: "#959595" }}>
                        <tr className="text-center">
                          <th>Article Name</th>
                          <th>Category</th>
                          <th>Variant combination</th>
                          <th>Image</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr className="text-center">
                          <td className="align-middle">
                            {graphData !== null &&
                              graphData?.articleName !== null &&
                              graphData?.articleName !== ""
                              ? graphData?.articleName
                              : ""}
                          </td>
                          <td className="align-middle">
                            {graphData !== null &&
                              graphData?.categoryName !== null &&
                              graphData?.categoryName !== ""
                              ? graphData?.categoryName +
                              "/" +
                              graphData?.subCategoryName
                              : ""}
                          </td>
                          <td className="align-middle">
                            <div className="d-flex flex-wrap">
                              {graphData !== null &&
                                graphData?.articleVariantCombinationList.length >
                                0 ? (
                                graphData?.articleVariantCombinationList?.map(
                                  (item, i) => (
                                    <div className="avariantCombinationitem">
                                      {item.attributeValue1 != "" &&
                                        item.attributeValue2 != "" &&
                                        item.attributeValue3 != "" &&
                                        item.attributeValue4 != "" &&
                                        item.attributeValue5 != "" ? (
                                        <div className="align-middle">
                                          {item.attributeValue1 +
                                            " / " +
                                            item.attributeValue2 +
                                            " / " +
                                            item.attributeValue3 +
                                            " / " +
                                            item.attributeValue4 +
                                            " / " +
                                            item.attributeValue5}
                                        </div>
                                      ) : item.attributeValue1 != "" &&
                                        item.attributeValue2 != "" &&
                                        item.attributeValue3 != "" &&
                                        item.attributeValue4 != "" &&
                                        item.attributeValue5 === "" ? (
                                        <div className="align-middle">
                                          {item.attributeValue1 +
                                            " / " +
                                            item.attributeValue2 +
                                            " / " +
                                            item.attributeValue3 +
                                            " / " +
                                            item.attributeValue4}
                                        </div>
                                      ) : item.attributeValue1 != "" &&
                                        item.attributeValue2 != "" &&
                                        item.attributeValue3 != "" &&
                                        item.attributeValue4 === "" &&
                                        item.attributeValue5 === "" ? (
                                        <div className="align-middle">
                                          {item.attributeValue1 +
                                            " / " +
                                            item.attributeValue2 +
                                            " / " +
                                            item.attributeValue3}
                                        </div>
                                      ) : item.attributeValue1 != "" &&
                                        item.attributeValue2 != "" &&
                                        item.attributeValue3 === "" &&
                                        item.attributeValue4 === "" &&
                                        item.attributeValue5 === "" ? (
                                        <div className="align-middle">
                                          {item.attributeValue1 +
                                            " / " +
                                            item.attributeValue2}
                                        </div>
                                      ) : item.attributeValue1 != "" &&
                                        item.attributeValue2 === "" &&
                                        item.attributeValue3 === "" &&
                                        item.attributeValue4 === "" &&
                                        item.attributeValue5 === "" ? (
                                        <div className="align-middle">
                                          {item.attributeValue1}
                                        </div>
                                      ) : (
                                        <></>
                                      )}
                                    </div>
                                  )
                                )
                              ) : (
                                <div className="avariantCombinationitem">
                                  N/A
                                </div>
                              )}
                            </div>
                          </td>

                          <td className="align-middle">
                            {/* <img
                            src="../assets/img/user/user-6.jpg"
                            style={{ height: "50px" }}
                          ></img> */}
                            {graphData?.articleImageUrl !== null &&
                              graphData?.articleImageUrl !== "" &&
                              graphData?.articleImageUrl !== "" ? (
                              <img
                                src={
                                  Config?.contentUrl +
                                  graphData?.articleImageUrl
                                }
                                onError={({ currentTarget }) => {
                                  currentTarget.onerror = null; // prevents looping
                                  currentTarget.src =
                                    "../assets/img/noimage.jpg";
                                }}
                                // src="../assets/img/user/user-7.jpg"
                                style={{ height: "50px" }}
                              ></img>
                            ) : (
                              "N/A"
                            )}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-xl-6">
          <div className="card border-0 bg-dark text-white mb-3 overflow-hidden">
            <div className="card-body p-0">
              <div className="row">
                <div className="col-xl-6 col-lg-8 col-xs-6">
                  <div style={{ padding: '15px' }}>
                    <div className="mb-3 text-grey">
                      <b className="mb-3 text-uppercase">TOTAL SCANS</b>
                    </div>
                    <div className="d-flex mb-1">
                      <h1 className="text-white mb-0 main-bold-text">
                        {graphData !== null && graphData?.totalScanCount !== null
                          ? graphData?.totalScanCount
                          : "0"}
                      </h1>
                    </div>
                  </div>  
                </div>
                <div className="col-xl-6 col-lg-4 col-xs-6  align-items-center d-flex justify-content-end">
                  <img
                    src="../assets/img/theme/dashboard2.png"
                    alt=""
                    className="images-change"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-6">
          <div className="card border-0 bg-dark text-white text-truncate mb-3">
            <div className="card-body p-0">
              <div className="row">
                <div className="col-xl-6 col-lg-8 col-xs-6">
                  <div style={{ padding: '15px' }}>
                    <div className="mb-3 text-grey">
                      <b className="mb-3 text-uppercase">
                        Saved to stt smart wallet
                      </b>
                    </div>
                    <div className="d-flex mb-1">
                      <h1 className="text-white mb-0 main-bold-text">
                        {graphData !== null &&
                          graphData?.totalSTTWalletSavedCount !== null
                          ? graphData?.totalSTTWalletSavedCount
                          : "0"}
                      </h1>
                    </div>
                    <div className="d-flex align-items-center mb-1 mt-4">
                      <h1 className="text-white mb-0">
                        {graphData !== null &&
                          graphData?.totalSTTWalletSavedPercent !== null
                          ? graphData?.totalSTTWalletSavedPercent
                          : "0"}
                        %
                      </h1>
                    </div>
                  </div>
                </div>

                <div className="col-xl-6 col-lg-4  col-xs-6 align-items-center d-flex justify-content-end">
                  <img
                    src="../assets/img/theme/dashboard1.png"
                    alt=""
                    className="images-change"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row change-header-bg">
        <div className="col-xl-8 pb-4">
          <Panel className="penal-stretch">
            <PanelHeader className="bg-dark-blue">
              <h4 className="mb-0 text-grey">Time wise Analysis</h4>
            </PanelHeader>
            <PanelBody className="bg-dark-blue">
              <div className="mb-1">
                <h1 className="text-white mb-0">
                  {graphData !== null && graphData?.totalScanCount !== null
                    ? graphData?.totalScanCount
                    : "0"}
                </h1>
              </div>
              <div className="text-grey">
                <b className="mb-3">TOTAL SCANS</b>
              </div>
              <div style={{ height: "291px" }}>
                <div
                  className="widget-chart-full-width nvd3-inverse-mode"
                  style={{ height: "300px" }}
                >
                  {graphData !== null &&
                    graphData?.articleTimeWiseScanList?.length > 0 ? (
                    <NVD3Chart
                      type="stackedAreaChart"
                      //datum={areaChartData}
                      datum={graphData?.articleTimeWiseScanList}
                      height={300}
                      options={areaChartOptions}
                    />
                  ) : (
                    <></>
                  )}
                  {graphData?.articleTimeWiseScanList?.length > 0 && (
                    <button
                      onClick={(e) => {
                        GetArticleTimeWiseScanningAnalyticReport();
                      }}
                      type="button"
                      className="btn btn-primary btn-xs ml-3"
                    >
                      Details
                    </button>
                  )}
                </div>
              </div>
            </PanelBody>
          </Panel>
        </div>
        <TimeWiseAnalysis isOpen={IstimewisemodalOpen} toggleLableTableclosed={()=>{ToggleTimewisemodalOpen()}} articleTimeWiseScanListDetalis={articleTimeWiseScanListDetalis}></TimeWiseAnalysis>
       <div className="col-xl-4 pb-4 countrywisecss">
          <Panel className="penal-stretch">
            <PanelHeader className="bg-dark-blue">
              <h4 className="mb-0 text-grey">Country wise scans</h4>
            </PanelHeader>
            <PanelBody className="bg-dark-blue">
              {/* <div className="bg-black mb-3" style={{ height: "155px" }}>
                <GoogleMapReact
                  defaultCenter={map.center}
                  defaultZoom={map.zoom}
                ></GoogleMapReact>
              </div> */}
              <div>
                <div className="widget-list widget-list-rounded inverse-mode ">
                  <div className="widget-list-item">
                    <h4 className="widget-list-action text-nowrap text-white pb-1 pt-1 text-left">
                      Country
                    </h4>
                    <h4 className="widget-list-action text-nowrap text-white pb-1 pt-1">
                      Scans
                    </h4>
                  </div>
                  <div className="table-responsive">
                    {DatatablecountryWiseScanLits?.slice(0, 5).map(
                      (countryWiseitem, i) => {
                        let CountryId = countryList.find(
                          (x) => x.name === countryWiseitem.name
                        );
                        return (
                          <>
                            <div className="widget-list-item ok">
                              <div
                                className="widget-list-media icon"
                                key={"Image" + i}
                              >
                                <div
                                  className="widget-img widget-img-xs rounded bg-inverse mr-2 width-40"
                                  style={{
                                    backgroundImage: `url(https://flagpedia.net/data/flags/normal/${CountryId?.code?.toLowerCase()}.png)`,
                                  }}
                                ></div>
                              </div>

                              <div
                                className="widget-list-content  pb-1 pt-1 border-none"
                                key={"name" + i}
                              >
                                <p className=" table-subtext">
                                  {countryWiseitem?.name}
                                </p>
                              </div>
                              <div className="widget-list-action text-nowrap  pb-1 pt-1">
                                <p
                                  className="table-scan-subtext"
                                  key={"totalScanCount" + i}
                                >
                                  {countryWiseitem?.totalScanCount}
                                </p>
                                <button
                                  key={"button" + i}
                                  onClick={(e) => {
                                    getCountrywisescanningDetail(
                                      countryWiseitem
                                    );
                                    // return false;
                                  }}
                                  type="button"
                                  className="btn btn-primary btn-xs ml-3"
                                >
                                  Details
                                </button>
                              </div>
                            </div>
                          </>
                        );
                      }
                    )}
                  </div>
                  <div className="text-center p-5">
                    {DatatablecountryWiseScanLits.length > 0 ? (
                      <button
                        type="button"
                        className="btn btn-purple m-5"
                        onClick={(e) => {
                          e.preventDefault();
                          setbestscancountryishow(true);
                        }}
                      >
                        See All
                      </button>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
                <Countrywisescans isOpen ={bestscancountryishow} 
                togglecountryTableclosed ={()=>{
                  togglecountryTableclosed()
                }}
                DatatablecountryWiseScanLits={DatatablecountryWiseScanLits}
                getCountrywisescanningDetail={(item)=>{
                  getCountrywisescanningDetail(item)
                }}
                ></Countrywisescans>
                <Modal
                  isOpen={modalCountry}
                  toggle={toggleCountry}
                  className="modal-size"
                >
                  <ModalHeader toggle={toggleCountry} className="modalheader ">
                    <div className="d-flex align-items-center">
                      <h4 className="text-white mb-0">
                        Locations country wise scans
                      </h4>
                      <button
                        className="btn btn-primary btm-sm ml-2"
                        onClick={(e) => handleActioncountry("DOWNLOAD")}
                      >
                        Download data
                      </button>
                      <CSVLink
                        headers={countrycsvheaders}
                        data={countrycsvdata}
                        filename={
                          "Country_" +
                          Moment(new Date()).format("DD-MM-Y HH:mm:ss") +
                          ".csv"
                        }
                        className="hidden"
                        ref={countrycsvRef}
                        target="_blank"
                      />
                    </div>
                  </ModalHeader>
                  <ModalBody>
                    <div className="sparkline8-list shadow-reset">
                      <div className="sparkline8-graph table-responsive">
                        <table
                          id="data-table-buttons"
                          className="table table-striped table-bordered table-td-valign-middle text-center"
                        >
                          <thead>
                            <tr className="odd gradeA">
                              <th className="text-nowrap">Sr #</th>
                              <th className="text-nowrap">Country</th>
                              <th className="text-nowrap">City</th>
                              <th className="text-nowrap">Scans</th>
                              <th className="text-nowrap">Details</th>
                            </tr>
                          </thead>
                          <tbody>
                            {Locationswisecanning.length > 0 &&
                              Locationswisecanning.map((item, i) => (
                                <tr>
                                  <td>{i + 1}</td>
                                  <td>{item.countryName}</td>
                                  <td>
                                    {item.cityName ? item.cityName : ""}
                                  </td>
                                  <td>{item.totalScanCount}</td>
                                  <td>
                                    <button
                                      onClick={(e) => {
                                        getcitywisescanningDetail(item);
                                        // return false;
                                      }}
                                      type="button"
                                      className="btn btn-primary btn-xs ml-3"
                                    >
                                      Details
                                    </button>
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </ModalBody>
                </Modal>
                <Modal
                  isOpen={modalCity}
                  toggle={toggleCity}
                  className="modal-size"
                >
                  <ModalHeader toggle={toggleCity} className="modalheader ">
                    <div className="d-flex align-items-center">
                      <h4 className="text-white mb-0">
                        Locations city wise scans
                      </h4>
                      
                      <button
                        className="btn btn-primary btm-sm ml-2"
                        onClick={(e) => handleActionCity("DOWNLOAD")}
                      >
                        Download data
                      </button>
                      <CSVLink
                        headers={Citycsvheaders}
                        data={Citycsvdata}
                        // filename={'city.csv'}
                        filename={
                          "City_" +
                          Moment(new Date()).format("DD-MM-Y HH:mm:ss") +
                          ".csv"
                        }
                        className="hidden"
                        ref={CitycsvRef}
                        target="_blank"
                      />
                    </div>
                  </ModalHeader>
                  <ModalBody>
                    {LocationsCitywisecanning.length !== null ? (
                      <div>
                        <div className="sparkline8-list shadow-reset">
                          <div className="sparkline8-graph table-responsive">
                            {bestsCityallshow === true ? (
                              <Locationscitywisescans LocationsCitywisecanning={LocationsCitywisecanning}></Locationscitywisescans>
                             
                            ) : (
                              <table
                                id="data-table-buttons"
                                className="table table-striped table-bordered table-td-valign-middle text-center"
                              >
                                <thead>
                                  <tr className="odd gradeA">
                                    <th className="text-nowrap">Sr #</th>
                                    <th className="text-nowrap">Country</th>
                                    <th className="text-nowrap">City</th>
                                    <th className="text-nowrap">
                                      QR Code Name
                                    </th>
                                    {/* <th className="text-nowrap">Type</th> */}
                                    <th className="text-nowrap">Pic</th>
                                    <th className="text-nowrap">Total Scans</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {LocationsCitywisecanning.length > 0 &&
                                    LocationsCitywisecanning.slice(0, 5).map(
                                      (item, i) => (
                                        <tr>
                                          <td>{i + 1}</td>
                                          <td>{item.countryName}</td>
                                          <td>
                                            {item.cityName
                                              ? item.cityName
                                              : ""}
                                          </td>
                                          <td>
                                            {item.productName
                                              ? item.productName
                                              : ""}
                                          </td>

                                          <td>
                                            <div>
                                              {item?.qrcodeType ===
                                                "personalqrcode" ? (
                                                <img
                                                  src="../assets/img/mtsttqr.png"
                                                  style={{ height: "50px" }}
                                                  onError={({
                                                    currentTarget,
                                                  }) => {
                                                    currentTarget.onerror =
                                                      null; // prevents looping
                                                    currentTarget.src =
                                                      "../assets/img/noimage.jpg";
                                                  }}
                                                ></img>
                                              ) : (
                                                <img
                                                  src={
                                                    Config?.contentUrl +
                                                    item?.productImagepath
                                                  }
                                                  style={{ height: "50px" }}
                                                  onError={({
                                                    currentTarget,
                                                  }) => {
                                                    currentTarget.onerror =
                                                      null; // prevents looping
                                                    currentTarget.src =
                                                      "../assets/img/mtsttqr.png";
                                                  }}
                                                ></img>
                                              )}
                                            </div>
                                          </td>
                                          <td>{item.totalScanCount}</td>
                                        </tr>
                                      )
                                    )}
                                </tbody>
                              </table>
                            )}
                          </div>
                        </div>
                        <div className="text-center">
                          {bestsCityallshow === true ? (
                            <button
                              type="button"
                              className="btn btn-purple m-5"
                              onClick={(e) => {
                                setbestsCityallshow(false);
                              }}
                            >
                              Hide
                            </button>
                          ) : (
                            <button
                              type="button"
                              className="btn btn-purple m-5"
                              onClick={(e) => {
                                setbestsCityallshow(true);
                              }}
                            >
                              See All
                            </button>
                          )}
                        </div>
                      </div>
                    ) : (
                      <></>
                    )}
                  </ModalBody>
                </Modal>
              </div>
            </PanelBody>
          </Panel>
        </div>
      </div>

      <div className="row change-header-bg">
        <div className="col-xl-6 pb-4">
          <Panel className="penal-stretch">
            <PanelHeader className="bg-dark-blue">
              <h4 className="mb-0 text-grey">Operating system wise scanning</h4>
            </PanelHeader>
            <PanelBody className="bg-dark-blue">
              <div style={{ height: "325px" }}>
                {/* <Pie data={pieChart.data} options={pieChart.options} /> */}
                {graphData !== null && graphData?.pipeBarchat !== null ? (
                  <Pie
                    data={graphData?.pipeBarchat}
                    options={pieChart.options}
                  />
                ) : (
                  <></>
                )}
              </div>
            </PanelBody>
          </Panel>
        </div>
        <div className="col-xl-6 pb-4">
          <Panel className="penal-stretch">
            <PanelHeader className="bg-dark-blue">
              <h4 className="mb-0 text-grey">Article performing label</h4>
            </PanelHeader>
            <PanelBody className="bg-dark-blue">
              <div className="table-responsive">
                <table
                  className="table table-bordered m-b-0"
                  style={{ color: "#FFFFFF" }}
                >
                  <thead style={{ backgroundColor: "#959595" }}>
                    <tr className="text-center">
                      <th>Sr #</th>
                      <th>Label</th>
                      <th>Image</th>
                      <th>Total scans</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      // graphData !== null && graphData?.articlePerformLabelWiseList.map((item, i) => (
                      DatatableLebalList?.length > 0 &&
                      DatatableLebalList.slice(0, 3).map((item, i) => (
                        <tr className="text-center">
                          <td className="align-middle">{i + 1}</td>
                          <td className="align-middle">
                            {item.labelName ? item.labelName : ""}
                          </td>
                          <td>
                            <div>
                              <img
                                src={Config?.contentUrl + item?.logoPath}
                                onError={({ currentTarget }) => {
                                  currentTarget.onerror = null; // prevents looping
                                  currentTarget.src =
                                    "../assets/img/noimage.jpg";
                                }}
                                // src="../assets/img/user/user-7.jpg"
                                style={{ height: "50px" }}
                              ></img>
                            </div>
                          </td>
                          <td className="align-middle">
                            {item.totalLabelScanCount}
                            <button
                              type="button"
                              className="btn btn-primary btn-xs ml-3"
                              onClick={(e) => {
                                // toggleLabel(item);
                                getLablewisescanningDetail(item);
                              }}
                            >
                              Details
                            </button>
                          </td>
                        </tr>
                      ))
                    }
                  </tbody>
                </table>

                <div className="text-center my-3">
                  {DatatableLebalList?.length > 0 ? (
                    <button
                      type="button"
                      className="btn btn-purple m-5"
                      onClick={(e) => {
                        setbestScanLableishow(true);
                      }}
                    >
                      See All
                    </button>
                  ) : (
                    <></>
                  )}
                </div>

                <Articleperforminglabel
                isOpen={bestScanLableishow}
                toggleLableTableclosed={
                  ()=>{toggleLableTableclosed()}
                }
                DatatableLebalList={DatatableLebalList}
                getLablewisescanningDetail={(item)=>{getLablewisescanningDetail(item)}}>
                </Articleperforminglabel>
              
                <Modal
                  isOpen={modalLabel}
                  toggle={toggleLabel}
                  className="modal-size"
                >
                  <ModalHeader toggle={toggleLabel} className="modalheader ">
                    <div className="d-flex align-items-center">
                      <h4 className="text-white mb-0">
                        Best performing label detail
                      </h4>

                      <button
                        className="btn btn-primary btm-sm ml-2"
                        onClick={(e) => handleActionLable("DOWNLOAD")}
                      >
                        Download data
                      </button>
                      <CSVLink
                        headers={Lablecsvheaders}
                        data={Lablecsvdata}
                        filename={
                          "Lable_" +
                          Moment(new Date()).format("DD-MM-Y HH:mm:ss") +
                          ".csv"
                        }
                        className="hidden"
                        ref={LablecsvRef}
                        target="_blank"
                      />
                    </div>
                  </ModalHeader>
                  <ModalBody>
                    <div className="sparkline8-list shadow-reset">
                      <div className="sparkline8-graph table-responsive">
                        {bestScanLabelDetlisisall === false ? (
                          <table
                            id="data-table-buttons"
                            className="table table-striped table-bordered table-td-valign-middle text-center"
                          >
                            <thead>
                              <tr className="odd gradeA">
                                <th className="text-nowrap">Sr #</th>
                                <th className="text-nowrap">Label</th>
                                <th className="text-nowrap">Name</th>
                                <th className="text-nowrap">Logo</th>
                                <th className="text-nowrap">Total Scans</th>
                              </tr>
                            </thead>
                            <tbody>
                              {Lablewisecanning.length > 0 &&
                                Lablewisecanning.map((item, i) => (
                                  <tr>
                                    <td>{i + 1}</td>
                                    <td>{item.lableName}</td>
                                    <td>
                                      {item.productName
                                        ? item.productName
                                        : ""}
                                    </td>
                                    <td>
                                      <div>
                                        <img
                                          // src="../assets/img/user/user-13.jpg"
                                          src={
                                            Config?.contentUrl +
                                            item?.productImagepath
                                          }
                                          style={{ height: "50px" }}
                                          onError={({ currentTarget }) => {
                                            currentTarget.onerror = null; // prevents looping
                                            currentTarget.src =
                                              "../assets/img/noimage.jpg";
                                          }}
                                        ></img>
                                      </div>
                                    </td>
                                    <td>{item.totalScanCount}</td>
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        ) : (
                          <Bestperforminglabeldetail Lablewisecanning ={Lablewisecanning}></Bestperforminglabeldetail>
                        
                        )}
                      </div>
                    </div>
                    <div className="text-center">
                      {Lablewisecanning.length > 0 &&
                        bestScanLabelDetlisisall === false ? (
                        <button
                          type="button"
                          className="btn btn-purple m-5"
                          onClick={(e) => {
                            setbestScanLabelDetlisisall(true);
                          }}
                        >
                          See All
                        </button>
                      ) : (
                        <button
                          type="button"
                          className="btn btn-purple m-5"
                          onClick={(e) => {
                            setbestScanLabelDetlisisall(false);
                          }}
                        >
                          Hide
                        </button>
                      )}
                    </div>
                  </ModalBody>
                </Modal>
              </div>
            </PanelBody>
          </Panel>
        </div>
      </div>
    </div>
  );
};


export default Articlereports;
